module.exports = __webpack_public_path__ + "img/title-page-img.495a295a.png";